<a class="am-flex-column b-radius-wide bg-white height-full am-flex-1 text-s p-m reset-link" [class.hover-active]="!loading" [href]="item?.url" target="_blank">
  <div class="am-flex-align-start am-flex-justify gap-s">
    <div class="am-flex-1 gap-s overflow">
      @if (loading) { <span class="mb-xs circle-64 loading-animate"></span>    }
      @else         { <img  class="mb-xs circle-64" [src]="candidatePhoto()"/> }
      <div class="am-flex-column am-flex-1 overlfow">
        @if (loading) { <span class="width-150 height-s loading-animate"></span> }
        @else         {
          <p class="color-title-grey ellipsis">
            {{ item?.last_name  || '' }},
            {{ item?.first_name || 'Anonymisiert' }}
          </p>
        }
        @if (loading) {
          <div class="am-flex-column gap-xxs">
            <span class="height-s loading-animate"></span>
            <span class="height-s loading-animate"></span>
          </div>
        } @else { <p class="height-max-54 overflow elipsis-3-line">{{ jobs() || '-' }}</p> }
      </div>
    </div>
    <span class="am-flex-align gap-xxs p-xxs word-no-wrap" [ngClass]="loading ? 'color-transparent loading-animate' : 'bg-green color-white b-green'">
      <span>ANSEHEN & ANFRAGEN</span>
      <span class="am-flex-center font-small-icon icon-external-link"></span>
    </span>
  </div>
  <div class="am-flex-justify gap-m bt-grey mt-s pt-s">
    <div class="am-flex-align gap-xs">
      @if (loading) {
        <span class="circle-l           loading-animate"></span>
        <span class="width-100 height-s loading-animate"></span>
      } @else {
        <span class="am-flex-center font-small-icon icon-location"></span>
        <span>{{ item?.city || 'Unbekannt' | capitalize }}</span>
      }
    </div>
    <div class="am-flex-align gap-xs">
      @if (loading) {
        <span class="circle-l           loading-animate"></span>
        <span class="width-100 height-s loading-animate"></span>
      } @else {
        <span [class]="`am-flex font-small-icon ${getAvailabilityIcon()}`"></span>
        <span>{{ getAvailabilityLabel() }}</span>
      }
    </div>
  </div>
</a>
